import styled from "@emotion/styled";
import { Trans } from "@lingui/react/macro";
import Image from "next/image";
import togglHireLogo from "./assets/toggl-hire-logo.svg";

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <Container>
      <Links>
        <Link
          href="https://toggl.com/hire/about"
          target="_blank"
          rel="noreferrer"
        >
          <Trans>About Toggl Hire</Trans>
        </Link>
        <Link
          href="https://toggl.com/hire/manifesto"
          target="_blank"
          rel="noreferrer"
        >
          <Trans>Our Manifesto</Trans>
        </Link>
      </Links>

      <Info>
        <Image src={togglHireLogo} alt="logo" height={30} />
        <Copyright>&copy; {year} Toggl Hire</Copyright>
      </Info>
    </Container>
  );
};

const Container = styled.div`
  background: ${(props) => props.theme.colors.purple[100]};
  padding: 36px;
  display: grid;
  gap: 32px;

  @media (min-width: 768px) {
    padding: 60px 172px;
  }
`;

const Links = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 32px;
  }
`;

const Info = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;

  @media (min-width: 768px) {
    gap: 32px;
  }
`;

const Link = styled.a`
  color: ${(props) => props.theme.colors.white};
  font-family: GT Haptik;
  font-size: 14px;
  font-weight: 500;
  opacity: 0.7;
`;

const Copyright = styled.div`
  color: ${(props) => props.theme.colors.white};
  font-family: GT Haptik;
  font-size: 12px;
  font-weight: 400;
  opacity: 0.5;
`;
